import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Utils } from './../../../utils/utils';
import { Serializer } from './../../../helpers/serializer/seriealizer';
import { SessionService } from './../../../services/session.service';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from './../../../tech-lib-portal.interceptor';

import { Observable, Observer, map } from 'rxjs';
import { LaboratoryServiceEnum } from '../../../services/api-names';
import { CriteriaInterface } from '../response/interfaces/criteria.interface';
import { CriteriaResponse } from '../response/models/criteria.response';
import { AssetRecom } from '../response/models/asset-recom.response';
import { AssetRecomInterface } from '../response/interfaces/asset-recom.interface';
import { StatusResultInterface } from '../response/interfaces/status-result.interface';
import { StatusResultModel } from '../response/models/status-result.model';

@Injectable({
  providedIn: 'root',
})
export class LaboratoryService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.clientCode = this.session.clientCode;
  }

  getCriterias(): Observable<CriteriaInterface[]> {
    this.updateSession();

    const url =
      this.config.baseApi +
      LaboratoryServiceEnum.apirest_portal_assetrecom_criterias;

    return new Observable((observer: Observer<CriteriaResponse[]>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJsonArray(resp, CriteriaResponse);
            return t;
          })
        )
        .subscribe({
          next(resp: any) {
            observer.next(resp);
            observer.complete();
          },
          error(err) {
            observer.error(err);
          },
        });
    });
  }

  getAssetRecom(
    code: string,
    value: string
  ): Observable<AssetRecomInterface[]> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        LaboratoryServiceEnum.apirest_portal_assetrecom_by_code_value,
      [code, value]
    );

    return new Observable((observer: Observer<AssetRecomInterface[]>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJsonArray(resp, AssetRecom);
            return t;
          })
        )
        .subscribe({
          next(resp: any) {
            observer.next(resp);
            observer.complete();
          },
          error(err) {
            observer.error(err);
          },
        });
    });
  }

  addFavourite(code: string): Observable<StatusResultInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        LaboratoryServiceEnum.apirest_portal_assetrecom_favourite_add,
      [code]
    );

    return new Observable((observer: Observer<StatusResultInterface>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, StatusResultModel);
            return t;
          })
        )
        .subscribe({
          next(resp: any) {
            observer.next(resp);
            observer.complete();
          },
          error(err) {
            observer.error(err);
          },
        });
    });
  }

  deleteFavourite(code: string): Observable<StatusResultInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        LaboratoryServiceEnum.apirest_portal_assetrecom_favourite_delete,
      [code]
    );

    return new Observable((observer: Observer<StatusResultInterface>) => {
      this.httpClient
        .delete(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, StatusResultModel);
            return t;
          })
        )
        .subscribe({
          next(resp: any) {
            observer.next(resp);
            observer.complete();
          },
          error(err) {
            observer.error(err);
          },
        });
    });
  }
  public getSplineColor(data){
    let negativeColor: string = 'var(--negative-color)';
    let positiveColor: string = 'var(--positive-color)';
    let color:string;
    if(data[0].Value == data[data.length-1].Value)
      color = 'var(--cp-font-var-contentbox-color)';
    else
      color = (data[0].Value < data[data.length-1].Value)? positiveColor : negativeColor;
    return color
  }
}
